import { render } from "./upload_logo.vue?vue&type=template&id=f96a048a&scoped=true"
import script from "./upload_logo.vue?vue&type=script&lang=js"
export * from "./upload_logo.vue?vue&type=script&lang=js"

import "./upload_logo.vue?vue&type=style&index=0&id=f96a048a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96a048a"]])

export default __exports__